var $es = require('./js_common/_esjquery').$es;

class LayoutBuilder{

  constructor() {


    console.log({$es});



    this.classInit();

  }

  classInit(){

    $es(document).on('click','.add-element', handle_click);
    function handle_click(e) {

      // console.log(e);


      var $t = $es(this);

      if ($t.hasClass('add-element')) {

        // console.info("CEVA");

        // _builderLayers.append(dzswtl_settings.struct_layer_element);
        //
        // listeners_add_for_layer();
        //
        // arrange_layers();
        //
        // update_to_editor({
        //   'call_from': 'add-element'
        // });
      }
    }
  }


}

window.addEventListener('DOMContentLoaded', (event) => {
  console.log('DOM fully loaded and parsed');


  var lb = new LayoutBuilder();
});